<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ label || '...' }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <li class="breadcrumb-item text-muted">
              <router-link to="/admin" class="text-muted text-hover-primary">{{ $t('navigation.dashboard') }}</router-link>
            </li>
            <li class="breadcrumb-item text-muted">
              <router-link :to="{ name: 'rapports-hub-path' }" class="text-muted text-hover-primary">{{ $t('report.hub_title') }}</router-link>
            </li>
            <li class="breadcrumb-item text-dark">{{ label }}</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:220px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select_report form-select-sm border-primary w-200px me-5">
              <option value="all" selected>{{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" value="ecommerce">{{ $t('dashboard.ecommerce') }}</option>
              <option v-for="s in shops" :value="s.id" :key="s.id">{{ s.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div v-if="$can('report_download')" class="card-toolbar d-flex gap-2">
            <button class="btn btn-sm btn-light-danger" @click="exportReport('pdf')" :disabled="isExporting">
              <i class="bi bi-file-earmark-pdf me-1"></i>PDF
            </button>
            <button class="btn btn-sm btn-light-success" @click="exportReport('xlsx')" :disabled="isExporting">
              <i class="bi bi-file-earmark-excel me-1"></i>Excel
            </button>
            <button class="btn btn-sm btn-light-primary" @click="exportReport('csv')" :disabled="isExporting">
              <i class="bi bi-filetype-csv me-1"></i>CSV
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div class="container-xxl">
        <div class="d-flex flex-column flex-md-row">
          <!-- Menu latéral : changer de rapport sans repasser par le hub -->
          <div class="flex-column flex-md-row-auto w-md-225px mb-8 me-md-8">
            <div class="card card-flush">
              <div class="card-body p-3 report-nav-list">
                <router-link
                    v-for="r in reportsList"
                    :key="r.slug"
                    :to="{ name: 'rapports-viewer-path', params: { slug: r.slug } }"
                    class="report-nav-link"
                    :class="{ 'report-nav-link--active': r.slug === slug }"
                >
                  {{ r.label }}
                </router-link>
              </div>
            </div>
          </div>

          <!-- Contenu du rapport -->
          <div class="flex-lg-row-fluid">
      <div v-show="!isReady">
        <Loader />
      </div>

      <div v-show="isReady">
        <!-- Filtres (vues à cocher) -->
        <div v-if="viewOptions.length" class="card card-flush mb-8">
          <div class="card-body py-4">
            <div class="d-flex flex-wrap gap-4">
              <div class="form-check form-check-custom form-check-solid" v-for="opt in viewOptions" :key="opt.value">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'view_'+opt.value"
                    :value="opt.value"
                    v-model="selectedViews"
                >
                <label class="form-check-label" :for="'view_'+opt.value">{{ opt.label }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Résumé -->
        <div v-if="summary.length" class="row gy-5 g-xl-8 mb-8">
          <div class="col-md-4 col-sm-6" v-for="item in summary" :key="item.label">
            <div class="card card-flush h-100">
              <div class="card-body py-4">
                <div class="fs-6 fw-bold text-gray-400">{{ item.label }}</div>
                <div class="fs-3 fw-bolder text-dark">{{ fmtValue(item.value, item.type) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Répartition (breakdown) -->
        <div v-if="breakdown" class="card card-flush mb-8">
          <div class="card-header pt-5">
            <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ breakdown.title }}</span></h3>
          </div>
          <div class="card-body pt-2 pb-4">
            <div class="table-responsive">
              <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                <thead>
                  <tr class="fw-bolder text-muted fs-7 text-uppercase">
                    <th v-for="col in breakdown.columns" :key="col.key" :class="col.type !== 'string' ? 'text-end' : ''">
                      {{ col.label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in breakdown.rows" :key="i">
                    <td v-for="col in breakdown.columns" :key="col.key" :class="col.type !== 'string' ? 'text-end' : ''">
                      <span v-if="col.type === 'currency'">{{ fmt(row[col.key]) }}</span>
                      <span v-else>{{ row[col.key] }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Sections (une par vue cochée, ou une seule section sans titre pour un rapport simple) -->
        <div class="card card-flush mb-8" v-for="(section, si) in sections" :key="si">
          <div class="card-header pt-5" v-if="section.title">
            <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ section.title }}</span></h3>
          </div>
          <div class="card-body pt-6">
            <div v-if="!section.rows.length" class="text-center py-10">
              <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-else class="table-responsive section-table-scroll">
              <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                <thead>
                  <tr class="fw-bolder text-muted fs-7 text-uppercase">
                    <th v-for="col in section.columns" :key="col.key" :class="col.type !== 'string' ? 'text-end' : ''">
                      {{ col.label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in section.rows" :key="i">
                    <td v-for="col in section.columns" :key="col.key" :class="col.type !== 'string' ? 'text-end' : ''">
                      <span v-if="col.type === 'currency'">{{ fmt(row[col.key]) }}</span>
                      <span v-else>{{ row[col.key] === null || row[col.key] === undefined ? '—' : row[col.key] }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'

export default {
  components: { Loader },

  data() {
    return {
      slug: this.$route.params.slug,
      label: '',
      reportsList: [],
      summary: [],
      breakdown: null,
      sections: [],
      viewOptions: [],
      selectedViews: [],
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      isReady: false,
      isExporting: false,
      currency: '',
    }
  },

  watch: {
    shop_selected(val) {
      if (val) this.$nextTick(() => this.load())
    },
    selectedViews: {
      handler() {
        this.load()
      },
      deep: true,
    },
    '$route.params.slug'(val) {
      this.slug = val
      this.selectedViews = []
      this.load()
    },
    '$i18n.locale'(val) {
      // Les libellés (titres, colonnes, filtres, résumé) viennent du backend
      // et sont traduits via le header X-localization envoyé sur chaque
      // requête — contrairement au breadcrumb (texte purement frontend via
      // $t()), ils ne se mettent donc pas à jour tout seuls au changement de
      // langue : il faut relancer les requêtes pour les récupérer traduits.
      if (val) {
        this.loadReportsList()
        // Le re-render Vue du bouton daterangepicker remet son texte sur
        // $t('dashboard.loading') (le placeholder du template) — sans
        // réinitialiser le plugin ensuite, ce texte de chargement restait
        // affiché indéfiniment au lieu de la plage sélectionnée. initDateRange()
        // réinjecte le texte réel (via cb()) et relance déjà load() — pas
        // besoin de l'appeler une seconde fois ici.
        this.$nextTick(() => this.initDateRange())
      }
    },
  },

  async mounted() {
    this.isReady = false
    KTApp.initSelect2()
    await this.loadShops()
    await this.loadReportsList()
    await this.initSelect()
    this.initDateRange()
    const res = await this.$store.dispatch('shop/getCurrency')
    this.currency = res?.data?.currency_symbol || res?.data?.symbol_native || ''
    this.$store.dispatch('society/fetchSociety')
  },

  methods: {
    async loadReportsList() {
      try {
        const res = await axios.get('report/list')
        this.reportsList = Object.values(res.data.categories || {}).flat()
      } catch (e) {
        console.error(e)
      }
    },

    fmt(val) {
      if (val === null || val === undefined) return '—'
      return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        + (this.currency ? ' ' + this.currency : '')
    },

    fmtValue(val, type) {
      if (val === null || val === undefined) return '—'
      if (type === 'currency') return this.fmt(val)
      if (type === 'percent') return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %'
      if (type === 'number') return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      return val
    },

    async loadShops() {
      try {
        const res = await axios.get('/dashboard/shops')
        this.shops = res.data.shops || []
      } catch (e) {
        console.error(e)
      }
    },

    async initSelect() {
      const sel = $('body .kt_select_report')
      sel.select2()
      sel.change((e) => {
        if (e.target.name === 'filter') this.shop_selected = e.target.value
      })
    },

    initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let start = moment().subtract(29, 'days')
      let end = moment()

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'), i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')],
          firstDay: 1,
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      }, this.cb)

      this.cb(start, end)
    },

    async cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let display = element.querySelector('div')
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY')
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.load()
      }
    },

    viewsQuery() {
      return this.selectedViews.map(v => `views[]=${encodeURIComponent(v)}`).join('&')
    },

    async load() {
      this.isReady = false
      try {
        const res = await axios.get(
          `/report/${this.slug}/data?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}&${this.viewsQuery()}`
        )
        this.label = res.data.label
        this.sections = res.data.sections || []
        this.summary = res.data.summary || []
        this.breakdown = res.data.breakdown || null
        this.viewOptions = res.data.view_options || []
        // Reflète les vues réellement retenues par le backend (repli sur la
        // vue par défaut si aucune n'était cochée) sans redéclencher le watch.
        if (JSON.stringify(this.selectedViews) !== JSON.stringify(res.data.selected_views || [])) {
          this.selectedViews = res.data.selected_views || []
        }
      } catch (e) {
        console.error(e)
      }
      this.isReady = true
    },

    async exportReport(format) {
      this.isExporting = true
      try {
        const res = await axios.get(
          `/report/${this.slug}/export/${format}?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}&${this.viewsQuery()}`,
          { responseType: 'blob' }
        )
        const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.slug}.${format}`)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (e) {
        console.error(e)
        window.toastr['error'](i18n.global.t('notification.export_failed'))
      } finally {
        this.isExporting = false
      }
    },
  },
}
</script>

<style scoped>
.section-table-scroll {
  max-height: 480px;
  overflow-y: auto;
}
.section-table-scroll thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.report-nav-list {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

.report-nav-link {
  display: block;
  padding: 10px 14px;
  border-radius: 6px;
  color: #3f4254;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  margin-bottom: 4px;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.report-nav-link:hover {
  background-color: #f5f8fa;
}
.report-nav-link--active {
  /* couleur de la boutique (personnalisation), couleur par défaut sinon */
  background-color: rgba(var(--kt-primary-rgb, 11, 61, 135), 0.1);
  color: var(--kt-primary, #0b3d87);
}
</style>
